import { useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import VuiBox from "components/VuiBox";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import ProfileDetails from "./components/ProfileDetails";
import SecuritySettings from "./components/SecuritySettings";
import PixelSetup from "./components/PixelSetup";
import SideMenu from "./components/SideMenu";
import SubscriptionDetails from "./components/SubscriptionDetails";
import NotificationSettings from "./components/NotificationSettings";

function Overview() {
  const [selectedMenuItem, setSelectedMenuItem] = useState(0);
  const profileRef = useRef(null);
  const securityRef = useRef(null);
  const platformRef = useRef(null);
  const billingRef = useRef(null);
  const notificationRef = useRef(null);

  const handleMenuItemClick = (itemId) => {
    setSelectedMenuItem(itemId);
    switch (itemId) {
      case 0:
        profileRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case 1:
        platformRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case 2:
        securityRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case 3:
        notificationRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case 4:
        billingRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      default:
        break;
    }
  };

  return (
    <DashboardLayout>
      <VuiBox mt={5} mb={3} minHeight="calc(100vh - 180px)" sx={{ height: '100%', overflowY: 'auto' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3} sx={{ position: "sticky", top: "30px" }}>
            <SideMenu selectedItem={selectedMenuItem} onItemClick={handleMenuItemClick} />
          </Grid>
          <Grid item xs={12} lg={9}>
            <VuiBox ref={profileRef}>
              <ProfileDetails />
            </VuiBox>
            <VuiBox ref={platformRef} mt={3}>
              <PixelSetup />
            </VuiBox>
            <VuiBox ref={notificationRef} mt={3}>
              {/* <NotificationSettings /> */}
            </VuiBox>
            <Grid container spacing={3} mt={3} sx={{ display: "flex", alignItems: "stretch" }}>
              <Grid item xs={12} md={6}>
                <VuiBox ref={securityRef}>
                  <SecuritySettings />
                </VuiBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <VuiBox ref={billingRef}>
                  <SubscriptionDetails />
                </VuiBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;